import i18n from 'es2015-i18n-tag';
import { Field, FormikBag, FormikProps, withFormik } from 'formik';
import { compose } from 'ramda';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import * as yup from 'yup';
import Input from '../../../../common/ui-components/input/input.component';
import { AuthState } from '../../../auth/context/auth-context';
import { TeamAdvisor, TeamModel } from '../../models/team-model';
import FetchTeam from '../../resolver/fetch-team.component';
import { updateTeam } from '../../team-service';
import EditTeam from './edit-team.component';
import { withRouter } from 'react-router-dom';

interface EditSportTeamFormValue {
    name: string;
    sport: string;
    league: string;
    advisor?: TeamAdvisor;
}

const formSchema = yup.object().shape({
    name: yup
        .string()
        .trim()
        .required(),
    sport: yup
        .string()
        .trim()
        .required(),
    league: yup
        .string()
        .trim()
        .required(),
    advisor: yup.object().nullable(true)
});

type EditSportTeamProps = {
    team: TeamModel;
} & RouteComponentProps;

type EditSportTeam = EditSportTeamProps & FormikProps<EditSportTeamFormValue> & AuthState;

const onSave = (
    formValue: EditSportTeamFormValue,
    { props, setSubmitting }: FormikBag<EditSportTeamProps, EditSportTeamFormValue>
) => {
    const { id } = props.team;
    const { name, sport, league, advisor } = formValue;
    updateTeam({
        id,
        name,
        league,
        sport,
        advisor,
        isBusiness: false,
        members: props.team.members,
        accountId: props.team.accountId
    })
        .then(() => {
            props.history.goBack();
        })
        .finally(() => setSubmitting(false));
};

const EditSportTeam = (props: EditSportTeam) => {
    return (
        <EditTeam advisorLabel={i18n`Betreuer`} {...props}>
            <Field
                component={Input}
                title={i18n`Sportart`}
                name="sport"
                className="edit-team__form-field"
                required
            />
            <Field
                component={Input}
                title={i18n`Ligazugehörigkeit`}
                name="league"
                className="edit-team__form-field"
                required
            />
        </EditTeam>
    );
};

const enhance = compose(
    withRouter,
    withFormik({
        displayName: 'EditTeam',
        validationSchema: formSchema,
        handleSubmit: onSave,
        mapPropsToValues: ({ team }) => ({
            name: team.name,
            sport: team.sport,
            league: team.league,
            advisor: team.advisor
        })
    })
);

const Editor = enhance(EditSportTeam);

// @ts-ignore
export default () => <FetchTeam>{team => <Editor team={team} />}</FetchTeam>;
